import React, { useState, useEffect } from "react";
import { getIcons } from "../Constant/Constant";

const AssignOption = ({ title, teamList = [], totalLead, selectedIds = {}, onSelectTeam }) => {
    const icons = getIcons();
    const [selectedTeams, setSelectedTeams] = useState(selectedIds);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredTeams, setFilteredTeams] = useState(teamList);

    useEffect(() => {
        setFilteredTeams(
            teamList.filter((item) => item.name.toLowerCase().includes(searchTerm.toLowerCase()))
        );
    }, [searchTerm, teamList]);

    const totalAssigned = Object.values(selectedTeams).reduce((sum, count) => sum + count, 0);
    const remainingLeads = totalLead - totalAssigned;

    const handleSelect = (id) => {
        setSelectedTeams((prev) => {
            const newSelection = { ...prev };
            if (newSelection[id]) {
                delete newSelection[id];
            } else {
                newSelection[id] = 0;
            }
            onSelectTeam(newSelection, remainingLeads);
         
            return newSelection;
        });
    };

    const handleCountLeadChange = (id, value) => {
        const newValue = Number(value) || 0;


        if (newValue >= 0 && totalAssigned - (selectedTeams[id] || 0) + newValue <= totalLead) {
            setSelectedTeams((prev) => {
                const newSelection = { ...prev, [id]: newValue };
                onSelectTeam(newSelection, totalLead - Object.values(newSelection).reduce((sum, count) => sum + count, 0)); 
              return newSelection;
            });
        }
    };

    return (
        <div className="w-6/12 border border-gray-400 rounded-xl p-4 max-h-96 flex flex-col gap-4">
            <h1 className="font-semibold text-xl">{title}</h1>

      
            <div className="relative flex bg-gray-100 rounded-md h-10 gap-3 px-5">
                <img src={icons.searchIcon} alt="Search" className="w-5" />
                <input
                    type="search"
                    className="focus:outline-none bg-transparent w-full"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>


            <form>
                <div className="w-full rounded-md shadow-md h-64 overflow-auto flex flex-col gap-3 p-3">
                    {filteredTeams.length > 0 ? (
                        filteredTeams.map((item) => {
                            const id = item.teamId || item.id;
                            return (
                                <label
                                    key={id}
                                    htmlFor={id}
                                    className={`cursor-pointer w-full flex items-center rounded-md h-10 px-3 border border-gray-100 shadow-sm gap-4 ${
                                        selectedTeams[id] !== undefined ? "bg-blue-100" : ""
                                    }`}
                                >
                                    <div className="flex items-center justify-between w-full">
                                        <div onClick={() => handleSelect(id)} className="cursor-pointer">
                                            {item.name}
                                        </div>
                                        <div>
                                            <input
                                                type="number"
                                                min="0"
                                                max={totalLead} 
                                                value={selectedTeams[id] || ""}
                                                onChange={(e) => handleCountLeadChange(id, e.target.value)}
                                                className="w-14 border-2 border-slate-200 px-1"
                                                disabled={remainingLeads === 0 && !selectedTeams[id]} 
                                            />
                                        </div>
                                    </div>
                                </label>
                            );
                        })
                    ) : (
                        <p className="text-gray-500 text-center">No matching results</p>
                    )}
                </div>
            </form>
        </div>
    );
};

export default AssignOption;
